<script lang="ts">
	import type { Snippet } from 'svelte';
	import Mill from './logos/mill.svelte';

	interface Props {
		content: Snippet;
		image?: Snippet;
		contentHeight?: number;
	}

	let { content, image, contentHeight = $bindable(0) }: Props = $props();
</script>

<section class="scrollbar-hide relative flex h-full flex-col items-center overflow-y-auto pt-12">
	<Mill class="h-8 flex-shrink-0 text-green-3" />

	<div
		class="max-w-[520px] px-5 max-lg:flex max-lg:min-h-[50svh] max-lg:items-center"
		bind:clientHeight={contentHeight}
	>
		{@render content()}
	</div>

	{#if image}
		{@render image?.()}
	{/if}
</section>
